import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type MediaQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
}>

export type MediaQuery = {
	__typename?: 'Query'
	media: Array<{
		__typename: 'Media'
		mediaType: Types.MediaType
		url?: string | null
		id: string
		googleName?: string | null
		width?: number | null
		cloudflareID?: string | null
	}>
}

export type MediaConnectionQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
	first?: Types.InputMaybe<Types.Scalars['Int']['input']>
	after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
	before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>
	last?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type MediaConnectionQuery = {
	__typename?: 'Query'
	mediaConnection: {
		__typename?: 'MediaConnection'
		totalCount: number
		edges?: Array<{
			__typename?: 'MediaEdge'
			cursor: string
			node?: {
				__typename: 'Media'
				usageCount: number
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
		} | null> | null
		pageInfo: {
			__typename?: 'PageInfo'
			hasNextPage: boolean
			hasPreviousPage: boolean
			startCursor?: string | null
			endCursor?: string | null
		}
	}
}

export const MediaDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Media' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripID' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const MediaConnectionDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'MediaConnection' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'mediaConnection' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'tripId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'FragmentSpread',
															name: { kind: 'Name', value: 'MediaFields' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'usageCount' },
															arguments: [
																{
																	kind: 'Argument',
																	name: { kind: 'Name', value: 'tripID' },
																	value: {
																		kind: 'Variable',
																		name: { kind: 'Name', value: 'tripId' },
																	},
																},
															],
														},
													],
												},
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
	],
} as unknown as DocumentNode
